/**
 * @license
 * @preserve
 * MIT License
 *
 * Copyright (c) 2021 Gabriel Paul "Cley Faye" Risterucci
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 */
var HttpCodes;
(function (HttpCodes) {
    HttpCodes[HttpCodes["Continue"] = 100] = "Continue";
    HttpCodes[HttpCodes["CONTINUE"] = 100] = "CONTINUE";
    HttpCodes[HttpCodes["SwitchingProtocols"] = 101] = "SwitchingProtocols";
    HttpCodes[HttpCodes["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
    HttpCodes[HttpCodes["Processing"] = 102] = "Processing";
    HttpCodes[HttpCodes["PROCESSING"] = 102] = "PROCESSING";
    HttpCodes[HttpCodes["EarlyHints"] = 103] = "EarlyHints";
    HttpCodes[HttpCodes["EARLY_HINTS"] = 103] = "EARLY_HINTS";
    HttpCodes[HttpCodes["OK"] = 200] = "OK";
    HttpCodes[HttpCodes["Created"] = 201] = "Created";
    HttpCodes[HttpCodes["CREATED"] = 201] = "CREATED";
    HttpCodes[HttpCodes["Accepted"] = 202] = "Accepted";
    HttpCodes[HttpCodes["ACCEPTED"] = 202] = "ACCEPTED";
    HttpCodes[HttpCodes["NonAuthoritativeInformation"] = 203] = "NonAuthoritativeInformation";
    HttpCodes[HttpCodes["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
    HttpCodes[HttpCodes["NoContent"] = 204] = "NoContent";
    HttpCodes[HttpCodes["NO_CONTENT"] = 204] = "NO_CONTENT";
    HttpCodes[HttpCodes["ResetContent"] = 205] = "ResetContent";
    HttpCodes[HttpCodes["RESET_CONTENT"] = 205] = "RESET_CONTENT";
    HttpCodes[HttpCodes["PartialContent"] = 206] = "PartialContent";
    HttpCodes[HttpCodes["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
    HttpCodes[HttpCodes["MultiStatus"] = 207] = "MultiStatus";
    HttpCodes[HttpCodes["MULTI_STATUS"] = 207] = "MULTI_STATUS";
    HttpCodes[HttpCodes["AlreadyReported"] = 208] = "AlreadyReported";
    HttpCodes[HttpCodes["ALREADY_REPORTED"] = 208] = "ALREADY_REPORTED";
    HttpCodes[HttpCodes["IMUsed"] = 226] = "IMUsed";
    HttpCodes[HttpCodes["IM_USED"] = 226] = "IM_USED";
    HttpCodes[HttpCodes["MultipleChoices"] = 300] = "MultipleChoices";
    HttpCodes[HttpCodes["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
    HttpCodes[HttpCodes["MovedPermanently"] = 301] = "MovedPermanently";
    HttpCodes[HttpCodes["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
    HttpCodes[HttpCodes["Found"] = 302] = "Found";
    HttpCodes[HttpCodes["FOUND"] = 302] = "FOUND";
    HttpCodes[HttpCodes["SeeOther"] = 303] = "SeeOther";
    HttpCodes[HttpCodes["SEE_OTHER"] = 303] = "SEE_OTHER";
    HttpCodes[HttpCodes["NotModified"] = 304] = "NotModified";
    HttpCodes[HttpCodes["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
    HttpCodes[HttpCodes["UseProxy"] = 305] = "UseProxy";
    HttpCodes[HttpCodes["USE_PROXY"] = 305] = "USE_PROXY";
    HttpCodes[HttpCodes["TemporaryRedirect"] = 307] = "TemporaryRedirect";
    HttpCodes[HttpCodes["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
    HttpCodes[HttpCodes["PermanentRedirect"] = 308] = "PermanentRedirect";
    HttpCodes[HttpCodes["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
    HttpCodes[HttpCodes["BadRequest"] = 400] = "BadRequest";
    HttpCodes[HttpCodes["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    HttpCodes[HttpCodes["Unauthorized"] = 401] = "Unauthorized";
    HttpCodes[HttpCodes["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    HttpCodes[HttpCodes["PaymentRequired"] = 402] = "PaymentRequired";
    HttpCodes[HttpCodes["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
    HttpCodes[HttpCodes["Forbidden"] = 403] = "Forbidden";
    HttpCodes[HttpCodes["FORBIDDEN"] = 403] = "FORBIDDEN";
    HttpCodes[HttpCodes["NotFound"] = 404] = "NotFound";
    HttpCodes[HttpCodes["NOT_FOUND"] = 404] = "NOT_FOUND";
    HttpCodes[HttpCodes["MethodNotAllowed"] = 405] = "MethodNotAllowed";
    HttpCodes[HttpCodes["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
    HttpCodes[HttpCodes["NotAcceptable"] = 406] = "NotAcceptable";
    HttpCodes[HttpCodes["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
    HttpCodes[HttpCodes["ProxyAuthenticationRequired"] = 407] = "ProxyAuthenticationRequired";
    HttpCodes[HttpCodes["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
    HttpCodes[HttpCodes["RequestTimeout"] = 408] = "RequestTimeout";
    HttpCodes[HttpCodes["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
    HttpCodes[HttpCodes["Conflict"] = 409] = "Conflict";
    HttpCodes[HttpCodes["CONFLICT"] = 409] = "CONFLICT";
    HttpCodes[HttpCodes["Gone"] = 410] = "Gone";
    HttpCodes[HttpCodes["GONE"] = 410] = "GONE";
    HttpCodes[HttpCodes["LengthRequired"] = 411] = "LengthRequired";
    HttpCodes[HttpCodes["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
    HttpCodes[HttpCodes["PreconditionFailed"] = 412] = "PreconditionFailed";
    HttpCodes[HttpCodes["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
    HttpCodes[HttpCodes["PayloadTooLarge"] = 413] = "PayloadTooLarge";
    HttpCodes[HttpCodes["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    HttpCodes[HttpCodes["URITooLong"] = 414] = "URITooLong";
    HttpCodes[HttpCodes["URI_TOO_LONG"] = 414] = "URI_TOO_LONG";
    HttpCodes[HttpCodes["UnsupportedMediaType"] = 415] = "UnsupportedMediaType";
    HttpCodes[HttpCodes["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
    HttpCodes[HttpCodes["RangeNotSatisfiable"] = 416] = "RangeNotSatisfiable";
    HttpCodes[HttpCodes["RANGE_NOT_SATISFIABLE"] = 416] = "RANGE_NOT_SATISFIABLE";
    HttpCodes[HttpCodes["ExpectationFailed"] = 417] = "ExpectationFailed";
    HttpCodes[HttpCodes["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
    HttpCodes[HttpCodes["MisdirectedRequest"] = 421] = "MisdirectedRequest";
    HttpCodes[HttpCodes["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
    HttpCodes[HttpCodes["UnprocessableEntity"] = 422] = "UnprocessableEntity";
    HttpCodes[HttpCodes["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
    HttpCodes[HttpCodes["Locked"] = 423] = "Locked";
    HttpCodes[HttpCodes["LOCKED"] = 423] = "LOCKED";
    HttpCodes[HttpCodes["FailedDependency"] = 424] = "FailedDependency";
    HttpCodes[HttpCodes["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
    HttpCodes[HttpCodes["TooEarly"] = 425] = "TooEarly";
    HttpCodes[HttpCodes["TOO_EARLY"] = 425] = "TOO_EARLY";
    HttpCodes[HttpCodes["UpgradeRequired"] = 426] = "UpgradeRequired";
    HttpCodes[HttpCodes["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
    HttpCodes[HttpCodes["PreconditionRequired"] = 428] = "PreconditionRequired";
    HttpCodes[HttpCodes["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
    HttpCodes[HttpCodes["TooManyRequests"] = 429] = "TooManyRequests";
    HttpCodes[HttpCodes["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
    HttpCodes[HttpCodes["RequestHeaderFieldsTooLarge"] = 431] = "RequestHeaderFieldsTooLarge";
    HttpCodes[HttpCodes["REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
    HttpCodes[HttpCodes["UnavailableForLegalReasons"] = 451] = "UnavailableForLegalReasons";
    HttpCodes[HttpCodes["UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
    HttpCodes[HttpCodes["InternalServerError"] = 500] = "InternalServerError";
    HttpCodes[HttpCodes["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    HttpCodes[HttpCodes["NotImplemented"] = 501] = "NotImplemented";
    HttpCodes[HttpCodes["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
    HttpCodes[HttpCodes["BadGateway"] = 502] = "BadGateway";
    HttpCodes[HttpCodes["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
    HttpCodes[HttpCodes["ServiceUnavailable"] = 503] = "ServiceUnavailable";
    HttpCodes[HttpCodes["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    HttpCodes[HttpCodes["GatewayTimeout"] = 504] = "GatewayTimeout";
    HttpCodes[HttpCodes["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
    HttpCodes[HttpCodes["HTTPVersionNotSupported"] = 505] = "HTTPVersionNotSupported";
    HttpCodes[HttpCodes["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
    HttpCodes[HttpCodes["VariantAlsoNegotiates"] = 506] = "VariantAlsoNegotiates";
    HttpCodes[HttpCodes["VARIANT_ALSO_NEGOTIATES"] = 506] = "VARIANT_ALSO_NEGOTIATES";
    HttpCodes[HttpCodes["InsufficientStorage"] = 507] = "InsufficientStorage";
    HttpCodes[HttpCodes["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
    HttpCodes[HttpCodes["LoopDetected"] = 508] = "LoopDetected";
    HttpCodes[HttpCodes["LOOP_DETECTED"] = 508] = "LOOP_DETECTED";
    HttpCodes[HttpCodes["NotExtended"] = 510] = "NotExtended";
    HttpCodes[HttpCodes["NOT_EXTENDED"] = 510] = "NOT_EXTENDED";
    HttpCodes[HttpCodes["NetworkAuthenticationRequired"] = 511] = "NetworkAuthenticationRequired";
    HttpCodes[HttpCodes["NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})(HttpCodes || (HttpCodes = {}));
export default HttpCodes;
//# sourceMappingURL=codes.js.map